import Cookies, {CookieAttributes} from "js-cookie";

export class Users {
	public constructor() {

		if (("geolocation" in navigator)) {			
			navigator.geolocation.getCurrentPosition(
				(position) => {					
					this.updateLocationCookie(`${ position.coords.latitude},${ position.coords.longitude}`);
				},
				(error) => {
					console.warn(error);
					let message = "";
					switch (error.code) {
						case error.PERMISSION_DENIED:
						case error.POSITION_UNAVAILABLE:
						case error.TIMEOUT:
							this.updateLocationCookie(``);
							break;
					}

				}
			);
		}
	}
	
	
	updateLocationCookie(value: string) {
		
		const cookieAttributes: CookieAttributes = {
			expires: 1,
			sameSite: "none",
			secure: true
		};
		Cookies.set("Tensar_Location", value, cookieAttributes)
	}
}